import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'bs-digital-combo-prevention-icon',
    templateUrl: './pick-combo-prevention-icon.component.html',
    styleUrls: ['./pick-combo-prevention-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class PickComboPreventionIconComponent {
    @Input() isLinear: boolean;
    @Input() isEpcotEnabled: boolean;
}
